<div class="container">
  <pdq-heading element="h6">Okendo User ID</pdq-heading>
  <div class="general">
    <pdq-input
      [value]="okendoUserId"
      placeholder="Not configured"
      [readonly]="true"
      type="password"
      [clipboard]="!!okendoUserId"></pdq-input>
    @if (okendoUserId) {
      <p class="hint body-12-regular">To change your User ID, disconnect and reconnect.</p>
    } @else {
      <p class="hint body-12-regular">Click Connect at the top of the page to enter your Okendo User ID.</p>
    }
  </div>
</div>
